import React from "react";
import { Toaster } from "react-hot-toast";
import { TiTick } from "react-icons/ti";
import { useSelectors } from "redux-store/selectors";

// Define the themes
const lightTheme = {
  background: "#fff",
  color: "black",
  successBackground: "white",
  errorBackground: "lightcoral",
  iconColor: "green",
};

const darkTheme = {
  background: "#333",
  color: "#fff",
  successBackground: "#333",
  errorBackground: "red",
  iconColor: "white",
};

const CustomToast: React.FC = ({ children, ...props }: any) => {
  const { theme: isDarkModeEnabled } = useSelectors();

  const theme = isDarkModeEnabled.isDarkMode ? darkTheme : lightTheme;

  return (
    <Toaster
      position="bottom-right"
      toastOptions={{
        style: {
          background: theme.background,
          color: theme.color,
        },
        success: {
          style: {
            background: theme.successBackground,
          },
          icon: <TiTick size={30} color={theme.iconColor} />,
        },
        error: {
          style: {
            background: theme.errorBackground,
          },
        },
      }}
      {...props}
    >
      {children}
    </Toaster>
  );
};

export default CustomToast;
